import ReactPannellum from 'react-pannellum';
import { useEffect, useState, useLayoutEffect } from 'react';

import { availableAssetTypes } from '../../ThreeSixtyView/useAssets';

const defaultConfig = {
  autoLoad: true,
  maxHfov: 100,
  minHfov: 75,
  showZoomCtrl: true,
  mouseZoom: false,
  showFullscreenCtrl: false,
  ignoreGPanoXMP: true,
};

const useInterior360 = ({ getPanoramicImages, assetColor, deviceImages, assetType }) => {
  const panoramicImages = getPanoramicImages && getPanoramicImages();

  const [panoramicImageLoaded, setPanoramicImageLoaded] = useState(false);
  const [hideRotatingIcon, setHideRotatingIcon] = useState(false);

  useEffect(() => {
    setPanoramicImageLoaded(false);
  }, [assetColor]);

  // There is only one image for interior and this is the default
  const currentImage = deviceImages && deviceImages[0];
  const panoramicImage = panoramicImages && panoramicImages[0];
  const scenes = ReactPannellum.getAllScenes() || [];
  const { length: totalSceneLength } = scenes;
  const { url } = panoramicImage || {};
  const { url: currentImageUrl, alt } = currentImage || {};

  useEffect(() => {
    if (url) {
      ReactPannellum.addScene(assetColor, { ...defaultConfig, imageSource: url, preview: currentImageUrl });
    }
  }, [assetColor, url, currentImageUrl]);

  useEffect(() => {
    const findScene = () => scenes.find(s => Object.keys(s)[0] === assetColor);
    if (totalSceneLength && findScene()) {
      const panoramicPositions = [ReactPannellum.getPitch(), ReactPannellum.getYaw(), ReactPannellum.getHfov()];
      ReactPannellum.loadScene(assetColor, ...panoramicPositions);
    }
  }, [totalSceneLength, assetColor]);

  useEffect(() => {
    const viewer = ReactPannellum.getViewer();
    if (assetType.toLowerCase() === availableAssetTypes.interior.toLowerCase() && viewer) {
      viewer.resize();
    }
  }, [assetType]);

  useLayoutEffect(() => {
    const viewer = ReactPannellum.getViewer();
    if (viewer) {
      const handleInteractionStart = () => {
        setHideRotatingIcon(true);
      };

      viewer.on('mousedown', handleInteractionStart);
      viewer.on('touchstart', handleInteractionStart);

      return () => {
        viewer.off('mousedown', handleInteractionStart);
        viewer.off('touchstart', handleInteractionStart);
      };
    }
  }, [assetType, scenes]);

  useEffect(() => ReactPannellum.destroy(), []);

  return { url, alt, currentImageUrl, panoramicImageLoaded, setPanoramicImageLoaded, defaultConfig, hideRotatingIcon };
};

export default useInterior360;
